// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"f5eae24f","503":"7c0de745","551":"9b850c83","720":"4267159e","968":"8e30e68a"}[chunkId] + ".chunk.js";
};